import {
  type ClientOptions,
  createRpcClient,
  type RpcClient,
} from "@redotech/rpc/client";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { rpcDefinition } from "./definition";

export function createRedoPartnersRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): RpcClient<InferRpcDefinition<typeof rpcDefinition>> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoPartnersRpcClient = ReturnType<
  typeof createRedoPartnersRpcClient
>;
